import { useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { GetToken } from '@utils/storage';
import * as config from '@config';

function useGroupEnquiry(props) {
    const [fetching, setFetching] = useState(false);
    const [data, setData] = useState({});
    const abortControllerRef = useRef(null);

    const fetchData = useCallback(async (id) => {
        setFetching(true);
        abortControllerRef.current = new AbortController();
        // console.log('limit', limit, 'offset', offset);
        try {
            const response = await fetch(`${config.apiURL2}/group-travel/enquiries/${id}`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${GetToken()}` },
                signal: abortControllerRef.current.signal,
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'An error occurred while fetch a group enquiry');
            }
            const result = await response.json();
            setData(result.data);
            return result;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');
                throw new Error('Request was aborted');
            } else {
                console.error('Error fetch a group enquiry:', error);
            }
            throw error;
        } finally {
            setFetching(false);
        }
    }, []);

    const abort = useCallback(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
    }, []);

    return { fetching, data, fetchData, abort };
}

useGroupEnquiry.propTypes = {};

export default useGroupEnquiry;
